import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=a6354890&scoped=true"
var script = {}
import style0 from "./contact.vue?vue&type=style&index=0&id=a6354890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6354890",
  null
  
)

export default component.exports